/**
 * Payment / refund / dispute specific panel typography.
 *
 * These override a subset of PANEL_TEXT_STYLES so the payment family of detail
 * pages matches the Balance Hub pages, without affecting the ~20 other entity
 * types that share the panel infrastructure.
 */
export const PAYMENT_PANEL_TEXT_STYLES = {
  // Matches the Balance Hub card titles (shadcn CardTitle: text-base font-semibold)
  sectionTitle: 'text-base font-semibold text-foreground',
} as const;
